import React from 'react';

const Logo = ({ showText = true, size = "lg", className = "" }) => {
  const sizeMap = {
    "sm": { icon: "w-6 h-6", text: "text-base" },
    "md": { icon: "w-10 h-10", text: "text-xl" },
    "lg": { icon: "w-12 h-12", text: "text-xl" },
    "xl": { icon: "w-20 h-20", text: "text-3xl" },
    "2xl": { icon: "w-24 h-24", text: "text-4xl" },
    "3xl": { icon: "w-28 h-28", text: "text-5xl" },
    "4xl": { icon: "w-48 h-48", text: "text-6xl" },
  };

  const { icon: iconSize, text: textSize } = sizeMap[size] || sizeMap["lg"];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <img 
          src="/lovable-uploads/26466057-d144-4e69-a215-9ddb40e152f5.png" 
          alt="BrainCX Logo" 
          className={`object-contain ${iconSize}`}
          onError={(e) => {
            // Try other formats if the main image doesn't exist
            if (e.target.src.includes('.png')) {
              e.target.src = '/lovable-uploads/logo.png';
            } else if (e.target.src.includes('logo.png')) {
              e.target.src = '/lovable-uploads/logo.svg';
            } else {
              // Hide image and show SVG fallback
              e.target.style.display = 'none';
              const svg = e.target.nextSibling;
              if (svg) svg.style.display = 'block';
            }
          }}
        />
        {/* Fallback SVG - Interconnected bx symbol with gradient */}
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={`object-contain ${iconSize}`} style={{ display: 'none', filter: 'drop-shadow(0 0 8px rgba(195, 100%, 70%, 0.6))' }}>
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="hsl(195, 100%, 75%)" stopOpacity="1" />
              <stop offset="50%" stopColor="hsl(200, 100%, 70%)" stopOpacity="1" />
              <stop offset="100%" stopColor="hsl(215, 90%, 58%)" stopOpacity="1" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          {/* Interconnected bx symbol - smooth curves */}
          {/* 'b' vertical stroke */}
          <path 
            d="M 10 8 L 10 40 L 14 40" 
            stroke="url(#logoGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
            filter="url(#glow)"
          />
          {/* 'b' loop - curves inward and forms part of 'x' */}
          <path 
            d="M 14 40 Q 18 40, 20 36 Q 22 32, 22 28 Q 22 24, 20 22 Q 18 20, 14 20 L 14 8" 
            stroke="url(#logoGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            filter="url(#glow)"
          />
          {/* 'x' upper right diagonal (continuation of b loop) */}
          <path 
            d="M 22 28 L 32 18" 
            stroke="url(#logoGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
            filter="url(#glow)"
          />
          {/* 'x' upper left diagonal */}
          <path 
            d="M 22 28 L 30 20" 
            stroke="url(#logoGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
            filter="url(#glow)"
            opacity="0.9"
          />
          {/* 'x' lower right diagonal */}
          <path 
            d="M 22 28 L 32 38" 
            stroke="url(#logoGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
            filter="url(#glow)"
          />
          {/* 'x' lower left diagonal */}
          <path 
            d="M 22 28 L 30 36" 
            stroke="url(#logoGradient)" 
            strokeWidth="3" 
            strokeLinecap="round"
            fill="none"
            filter="url(#glow)"
            opacity="0.9"
          />
        </svg>
      </div>
      
      {showText && (
        <div>
          <h2 className={`${textSize} font-bold bg-gradient-primary bg-clip-text text-transparent`}>
            BrainCX AI
          </h2>
          <p className="text-sm text-muted-foreground">AI Dashboard</p>
        </div>
      )}
    </div>
  );
};

export default Logo;

